import React from "react";
import { reportError as notify } from "~/lib/reportErrors";


export class GlobalErrorBoundary extends React.PureComponent {
    state = { hasError: false };

    constructor(props) {
      super(props);
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }

  
    componentDidCatch(error) {
      // You can also log the error to an error reporting service
      notify(error);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <React.Fragment>{ this.props.errorMessage ?? null }</React.Fragment>
      }
  
      return this.props.children; 
    }
}